import { publish, publishSticky, subscribe } from '@wh/message-bus';
import {
  RADIO_STATE_UPDATED,
  RADIO_PAUSE_CLICKED,
  RADIO_PLAY_CLICKED,
  RADIO_MARQUEE_ANIMATION_START,
  RADIO_MUTE_TOGGLE,
  WH_RADIO_MUTE_REQUESTED,
  WH_RADIO_PAUSE_REQUESTED,
  WH_RADIO_PLAY_REQUESTED,
  WH_RADIO_UNMUTE_REQUESTED,
} from '../../topics';

export const muteRadio = () => {
  publish({ topic: WH_RADIO_MUTE_REQUESTED });
};

export const pauseRadio = () => {
  publish({ topic: WH_RADIO_PAUSE_REQUESTED });
};

export const playRadio = (id) => {
  publish({ topic: WH_RADIO_PLAY_REQUESTED, data: id });
};

export const unmuteRadio = () => {
  publish({ topic: WH_RADIO_UNMUTE_REQUESTED });
};

export const radioMarqueeAnimationSubscribe = (callback) => {
  subscribe({
    topic: RADIO_MARQUEE_ANIMATION_START,
    callback,
  });
};

export const radioPauseSubscribe = (callback) => {
  subscribe({
    topic: RADIO_PAUSE_CLICKED,
    callback,
  });
};

export const radioPlaySubscribe = (callback) => {
  subscribe({
    topic: RADIO_PLAY_CLICKED,
    callback,
  });
};

export const radioMuteToggleSubscribe = (callback) => {
  subscribe({
    topic: RADIO_MUTE_TOGGLE,
    callback,
  });
};

export const publishRadioState = (data) => {
  publishSticky(RADIO_STATE_UPDATED, data);
};
